'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/server.js
// module id = 511
// module chunks = 14